<template>
  <div>
    <p v-if="needsLogin" class="empty" role="status">
      {{ $t('intake.portal.needsLogin') }}
      <router-link class="btn btn-ghost" :to="{name: 'login', params: {lang}}">{{ $t('intake.portal.needsLoginCta') }}</router-link>
    </p>
    <div v-else-if="loading" class="empty"><p>{{ $t('intake.portal.loading') }}</p></div>
    <div v-else-if="!factor" class="empty">
      <h3>{{ $t('intake.portal.receiptMissingTitle') }}</h3>
      <p>{{ $t('intake.portal.receiptMissingBody') }}</p>
      <div class="actions">
        <router-link class="btn btn-primary" :to="paymentsLink">{{ $t('intake.portal.receiptBack') }}</router-link>
      </div>
    </div>
    <template v-else>
      <h2>{{ isPaid ? $t('intake.portal.receiptTitle') : $t('intake.portal.invoiceDetailsTitle') }}</h2>
      <p v-if="!isPaid" class="empty" role="status">{{ $t('intake.portal.invoiceNotReceipt') }}</p>
      <div class="detail-grid">
        <div class="detail-row">
          <span class="k">{{ $t('intake.portal.receipt_amount') }}</span>
          <span class="v">{{ amount }}</span>
        </div>
        <div class="detail-row">
          <span class="k">{{ $t('intake.portal.receipt_date') }}</span>
          <span class="v">{{ date }}</span>
        </div>
        <div class="detail-row">
          <span class="k">{{ $t('intake.portal.receipt_method') }}</span>
          <span class="v">{{ method }}</span>
        </div>
        <div class="detail-row">
          <span class="k">{{ $t('intake.portal.receipt_code') }}</span>
          <span class="v">{{ code }}</span>
        </div>
        <div class="detail-row">
          <span class="k">{{ $t('intake.portal.receipt_session') }}</span>
          <span class="v">{{ sessionLabel }}</span>
        </div>
        <div class="detail-row">
          <span class="k">{{ $t('intake.portal.receipt_status') }}</span>
          <span class="v">{{ status }}</span>
        </div>
      </div>
      <div class="actions">
        <router-link class="btn btn-primary" :to="paymentsLink">{{ $t('intake.portal.receiptBack') }}</router-link>
        <router-link
            class="btn btn-secondary"
            :to="{name: 'factor', params: {lang, factorID: factor.id}}"
        >
          {{ factor.canBePaid ? $t('intake.portal.receiptPayCta') : (lang === 'fa' ? 'مشاهدهٔ جزئیات کامل فاکتور' : 'View full invoice') }}
        </router-link>
        <router-link class="btn btn-secondary" :to="{name: 'portalRefund', params: {lang}, query: {id: String(factor.id)}}">{{ $t('intake.portal.refundSupportCta') }}</router-link>
      </div>
    </template>
  </div>
</template>
<script>
import {
  factorStateLabel,
  factorTitle,
  fetchFactor,
  formatFactorDate,
  formatMoneyAmount,
  hasAuthToken,
} from '@/intake/portalApi'

export default {
  name: 'PortalReceiptStep',
  data() {
    return {
      loading: true,
      needsLogin: false,
      factor: null,
      generation: 0,
    }
  },
  computed: {
    lang() {
      return this.$route.params.lang || 'fa'
    },
    paymentsLink() {
      const page = Number(this.$route.query.history_page)
      return {name: 'portalPayments', params: {lang: this.lang}, ...(Number.isSafeInteger(page) && page > 1 ? {query:{page:String(page)}} : {})}
    },
    isPaid() { return !!this.factor && String(this.factor.state || '').toLowerCase() === 'paid' },
    amount() {
      return formatMoneyAmount(this.factor.price, this.factor.currency_code || this.factor.currency, this.lang)
    },
    date() {
      return formatFactorDate(this.factor, this.lang) || '—'
    },
    method() {
      const payments = Array.isArray(this.factor.payments) ? this.factor.payments : []
      const last = payments[payments.length - 1]
      const type = last && last.type
      if (type === 'online') return this.$t('intake.portal.receiptMethodOnline')
      if (type === 'offline') return this.$t('intake.portal.receiptMethodOffline')
      if (type === 'wallet_debt_settlement') return this.$t('intake.portal.receiptMethodWallet')
      return this.$t('intake.portal.receiptMethodUnknown')
    },
    code() {
      const id = this.factor.id || this.factor.code || this.factor.tracking_code
      if (id == null) return '—'
      return String(id)
    },
    sessionLabel() {
      return factorTitle(this.factor, this.lang) || '—'
    },
    status() {
      return factorStateLabel(this.factor, this.lang)
    },
  },
  mounted() {
    this.bootstrap()
  },
  watch: {'$route.query.id'() { return this.bootstrap() }},
  beforeDestroy() { this.generation += 1 },
  methods: {
    bootstrap() {
      const generation = ++this.generation
      this.loading = true
      this.factor = null
      this.needsLogin = !hasAuthToken()
      if (this.needsLogin) {
        this.loading = false
        return
      }
      const wanted = this.$route.query.id != null ? String(this.$route.query.id).trim() : ''
      if (!wanted) {
        this.loading = false
        return this.$router.replace(this.paymentsLink)
      }
      return fetchFactor(wanted)
          .then((factor) => {
            if (generation !== this.generation) return
            if (!factor || String(factor.id) !== wanted) throw new Error('INVOICE_RESPONSE_INVALID')
            this.factor = factor
          })
          .catch(() => {
            if (generation === this.generation) this.factor = null
          })
          .finally(() => {
            if (generation === this.generation) this.loading = false
          })
    },
  },
}
</script>
